import { useEffect, useState } from 'react'
import { geocodeByAddress } from 'react-places-autocomplete'

import { ICoordinates } from 'modules/HomesForSale/types'

const GOOGLE_NO_RESULTS_CODE = 'ZERO_RESULTS'

type IUseLocationSearch = () => {
  searchType: 'address' | 'other'
  resetSearchType: () => void
  address: string
  setAddress: (value: string) => void
  foundSearchLocationCenter: ICoordinates | null
  foundSearchLocationGeocodedPlace: google.maps.GeocoderResult | null
  handleSetAddress: (_: string, value: string) => void
  searchByAddress: (event: any) => void
  // no result modal props
  searchedAddress: string
  noResultsModalVisible: boolean
  setNoResultsModalVisible: (value: boolean) => void
}

const useLocationSearch: IUseLocationSearch = () => {
  const [searchType, setSearchType] = useState<'address' | 'other'>('other')
  const resetSearchType = () => setSearchType('other')

  const [foundSearchLocationCenter, setFoundSearchLocationCenter] = useState<ICoordinates | null>(
    null,
  )
  const [foundSearchLocationGeocodedPlace, setFoundSearchLocationGeocodedPlace]
    = useState<google.maps.GeocoderResult | null>(null)

  const [noResultsModalVisible, setNoResultsModalVisible] = useState(false)

  const [address, setAddress] = useState('')
  const [searchedAddress, setSearchedAddress] = useState('')

  const handleSetAddress = (_: string, value: string) => setAddress(value)

  useEffect(() => {
    if (address === '') setSearchedAddress('') // clear search filter on clearing search bar
  }, [address])

  const searchByAddress = (event: any) => {
    event.preventDefault()
    setSearchedAddress(address)
  }

  useEffect(() => {
    const setCoordinates = async () => {
      try {
        const placeResults = await geocodeByAddress(`${searchedAddress} USA`)
        const place = placeResults.filter(placeResult => !placeResult.types.includes('country'))[0]
        console.warn({
          place,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        })

        const latitude = place.geometry.location.lat()
        const longitude = place.geometry.location.lng()

        if (latitude && longitude) {
          setFoundSearchLocationCenter({ latitude, longitude })
          setFoundSearchLocationGeocodedPlace(place)
          setAddress(place.formatted_address)
        }

        // we'll zoom in if the user searched for an exact address
        if (
          place.types.includes('street_address')
          || place.types.includes('premise')
          || place.types.includes('subpremise')
        ) {
          setSearchType('address')
        }
      } catch (error) {
        console.error({ error })
        if (error === GOOGLE_NO_RESULTS_CODE) setNoResultsModalVisible(true)
      }
    }

    console.warn({ searchedAddress })
    if (searchedAddress) setCoordinates()
  }, [searchedAddress])

  return {
    address,
    setAddress,
    handleSetAddress,
    foundSearchLocationCenter,
    foundSearchLocationGeocodedPlace,
    searchType,
    resetSearchType,
    searchByAddress,
    // no result modal props
    searchedAddress,
    noResultsModalVisible,
    setNoResultsModalVisible,
  }
}

export default useLocationSearch
